import { createStyles } from "@mantine/core";

const useStyles = createStyles(() => ({
  container: {
    display: "flex",
    backgroundColor: "#fff",
    width: "100%",
    height: "75px",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "1rem",
    borderBottom: "1px solid #E5E5E5",
    boxShadow: "0 1px 2px rgba(0, 0, 0, 0.1)",
  },
  right: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "1rem",
    " .mantine-Popover-dropdown": {
      padding: "0 !important",
    },
  },
  notificationBorder: {
    backgroundColor: "#E5E5E5",
    borderRadius: "50%",
    padding: "0.7rem",
    width: "50px",
    height: "50px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
  },
  header: {
    display: "flex",
    alignItems: "center",
    gap: "1rem",
    justifyContent: "space-between",
    width: "100%",
    padding: "1rem",
  },
  headerTitle: {
    display: "flex",
    alignItems: "center",
    gap: "1rem",
  },
  body: {
    display: "flex",
    alignItems: "start",
    flexDirection: "column",
    backgroundColor: "#F5F5F5",
    gap: "1rem",
    width: "100%",
    padding: "1rem",
    maxHeight: "500px",
    overflowY: "auto",
  },
  card: {
    display: "flex",
    alignItems: "flex-start",
    flexDirection: "column",
    width: "100%",
    padding: "1rem",
    backgroundColor: "#fff",
    borderRadius: "10px",
    border: "1px solid #E5E5E5",
    cursor: "pointer",
  },
  drawerCard: {
    display: "flex",
    alignItems: "flex-start",
    flexDirection: "column",
    width: "100%",
    padding: "1rem",
    backgroundColor: "#fff",
    borderRadius: "10px",
    border: "1px solid #E5E5E5",
    gap: "1rem",
    margin: "1rem 0",
    cursor: "pointer",
  },
  titleIndicator: {
    display: "flex",
    alignItems: "center",
    gap: "1rem",
  },
  drawer: {
    ".mantine-Drawer-content": {
      backgroundColor: "#f5f5f5",
    },
    ".mantine-Drawer-title": {
      fontSize: 20,
      fontWeight: 700,
      fontFamily: "Inter",
      color: "#000",
    },
    ".mantine-Drawer-header": {
      backgroundColor: "#fff",
    },
  },
  tabs: {
    marginTop: "1rem",
  },
  tabsList: {
    backgroundColor: "#fff",
    width: "fit-content",
  },
  empty: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "80vh",
  },
  noNotifications: {
    textAlign: "center",
    width: "100%",
  },
  loaderStyling: {
    display: "block",
    margin: "0 auto",
  },
}));

export default useStyles;
